import React from 'react'
import classnames from 'classnames'
import { intl } from 'lang/intl'
import { FormattedMessage } from 'react-intl'

import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent'
import { useWebinarFormatQuery } from '../../../../hooks/useWebinarFormatQuery'

interface HeaderProps {
  liveSeriesId?: number
  token?: string
  toggleSecondaryPanel: (panel: null | 'sessions') => void
  secondaryPanelContentType: null | 'sessions'
}

const Header = ({
  liveSeriesId,
  token,
  toggleSecondaryPanel,
  secondaryPanelContentType,
}: HeaderProps) => {
  const { data: series } = useWebinarFormatQuery(liveSeriesId, token)
  if (!series || series.seriesFormat === 'series-recurring') {
    return null
  }
  return (
    <div className="sidebar-header">
      <div className="webinar-sidebar-action-buttons-component">
        <div
          className={classnames('button-wrapper', {
            'selected-secondary-panel': !secondaryPanelContentType,
          })}
        >
          <ButtonComponent
            onClick={
              secondaryPanelContentType === 'sessions'
                ? () => {
                    toggleSecondaryPanel(null)
                  }
                : undefined
            }
            color="transparent"
            className="action-button"
            ariaLabel={intl.formatMessage({
              defaultMessage: 'Chat',
            })}
            size="small"
          >
            <FormattedMessage defaultMessage="Chat" />
          </ButtonComponent>
        </div>

        <div
          className={classnames('button-wrapper', {
            'selected-secondary-panel':
              secondaryPanelContentType === 'sessions',
          })}
        >
          <ButtonComponent
            onClick={
              secondaryPanelContentType !== 'sessions'
                ? () => {
                    toggleSecondaryPanel('sessions')
                  }
                : undefined
            }
            color="transparent"
            className="action-button"
            ariaLabel={intl.formatMessage({
              defaultMessage: 'Webinars',
            })}
            size="small"
          >
            <FormattedMessage defaultMessage="Webinars" />
          </ButtonComponent>
        </div>
      </div>
    </div>
  )
}

export default Header
